module.exports = __webpack_public_path__ + "static/kodiac-04@2x-23a011ec72d949da66cd27ca999f2579.png";